import { render, staticRenderFns } from "./Loading2.vue?vue&type=template&id=47aa0f92&scoped=true&"
import script from "./Loading2.vue?vue&type=script&lang=js&"
export * from "./Loading2.vue?vue&type=script&lang=js&"
import style0 from "./Loading2.vue?vue&type=style&index=0&id=47aa0f92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aa0f92",
  null
  
)

export default component.exports